
import React, { useState } from "react";
import { Link } from "react-router-dom";

const cards = [
  {
    key: "handyman",
    icon: "ri-tools-fill",
    title: "Handyman",
    subtitle: "Repairs & Installations",
    description:
      "From furniture assembly to wall mounting and general repairs — our verified handymen handle it all with care and precision.",
    bullets: [
      "Furniture assembly",
      "TV & wall mounting",
      "Door & lock repairs",
      "Shelving & fixtures",
    ],
    priceMain: "£40–£55",
    priceSuffix: "/hr",
    priceNote: "1hr minimum",
    image:
      "https://public.readdy.ai/ai/img_res/2967642ef0c3e39a81f8366570280834.jpg",
    accent: "from-orange-500 to-amber-500",
    accentLight: "bg-orange-50",
    iconBg: "bg-gradient-to-br from-orange-500 to-amber-500",
    borderColor: "border-orange-200",
    tagColor: "bg-orange-100 text-orange-700",
    tag: "Most Popular",
  },
  {
    key: "plumbing",
    icon: "ri-drop-fill",
    title: "Plumbing",
    subtitle: "Repairs & Maintenance",
    description:
      "Leaking taps, blocked drains, or appliance installations — our qualified plumbers deliver fast, reliable fixes.",
    bullets: [
      "Leaking taps & pipes",
      "Blocked drains",
      "Toilet & cistern repairs",
      "Appliance installation",
    ],
    priceMain: "£60–£80",
    priceSuffix: "/hr",
    priceNote: "1hr minimum",
    image:
      "https://readdy.ai/api/search-image?query=professional%20plumber%20in%20clean%20uniform%20repairing%20modern%20chrome%20kitchen%20tap%20with%20tools%20in%20bright%20contemporary%20home%20interior%20warm%20natural%20lighting%20clean%20simple%20background%20minimalist%20style&width=600&height=400&seq=pricing-plumbing-card-v3&orientation=landscape",
    accent: "from-sky-500 to-cyan-500",
    accentLight: "bg-sky-50",
    iconBg: "bg-gradient-to-br from-sky-500 to-cyan-500",
    borderColor: "border-sky-200",
    tagColor: "bg-sky-100 text-sky-700",
    tag: "Emergency Available",
  },
  {
    key: "electrical",
    icon: "ri-flashlight-fill",
    title: "Electrical",
    subtitle: "Minor Work & Checks",
    description:
      "Light replacements, socket installations, and safety checks — carried out by certified, insured electricians.",
    bullets: [
      "Light replacement",
      "Socket installation",
      "Fault finding",
      "Safety inspections",
    ],
    priceMain: "£55–£75",
    priceSuffix: "/hr",
    priceNote: "1hr minimum",
    image:
      "https://readdy.ai/api/search-image?query=qualified%20electrician%20in%20clean%20uniform%20installing%20modern%20light%20fixture%20on%20ceiling%20in%20bright%20contemporary%20home%20interior%20warm%20natural%20lighting%20clean%20simple%20background%20minimalist%20style&width=600&height=400&seq=pricing-electrical-card-v3&orientation=landscape",
    accent: "from-amber-500 to-yellow-500",
    accentLight: "bg-amber-50",
    iconBg: "bg-gradient-to-br from-amber-500 to-yellow-500",
    borderColor: "border-amber-200",
    tagColor: "bg-amber-100 text-amber-700",
    tag: "Certified Pros",
  },
  {
    key: "cleaning",
    icon: "ri-brush-fill",
    title: "Cleaning",
    subtitle: "Domestic & Property",
    description:
      "Deep cleans, end-of-tenancy, and regular maintenance — professional cleaners leaving your space spotless.",
    bullets: [
      "Deep cleaning",
      "End-of-tenancy",
      "Kitchen & bathroom",
      "Regular scheduled cleans",
    ],
    priceMain: "£30–£35",
    priceSuffix: "/hr",
    priceNote: "2hr minimum",
    image:
      "https://readdy.ai/api/search-image?query=professional%20cleaner%20in%20clean%20uniform%20deep%20cleaning%20modern%20bright%20kitchen%20with%20spray%20bottle%20and%20cloth%20in%20contemporary%20home%20interior%20warm%20natural%20lighting%20clean%20simple%20background%20minimalist%20style&width=600&height=400&seq=pricing-cleaning-card-v3&orientation=landscape",
    accent: "from-emerald-500 to-teal-500",
    accentLight: "bg-emerald-50",
    iconBg: "bg-gradient-to-br from-emerald-500 to-teal-500",
    borderColor: "border-emerald-200",
    tagColor: "bg-emerald-100 text-emerald-700",
    tag: "Best Value",
  },
  {
    key: "waste",
    icon: "ri-delete-bin-fill",
    title: "Waste Removal",
    subtitle: "All Waste Types",
    description:
      "Furniture, garden waste, or full house clearances — we handle responsible removal and recycling for you.",
    bullets: [
      "Furniture removal",
      "Garden waste",
      "House clearance",
      "Single item pickup",
    ],
    priceMain: "From £90",
    priceSuffix: "/load",
    priceNote: "Per van load",
    image:
      "https://readdy.ai/api/search-image?query=professional%20waste%20removal%20team%20loading%20old%20furniture%20into%20clean%20white%20van%20outside%20modern%20home%20on%20sunny%20day%20warm%20natural%20lighting%20clean%20simple%20background%20minimalist%20style&width=600&height=400&seq=pricing-waste-card-v3&orientation=landscape",
    accent: "from-rose-500 to-pink-500",
    accentLight: "bg-rose-50",
    iconBg: "bg-gradient-to-br from-rose-500 to-pink-500",
    borderColor: "border-rose-200",
    tagColor: "bg-rose-100 text-rose-700",
    tag: "Same Day",
  },
  {
    key: "transport",
    icon: "ri-truck-fill",
    title: "Transport",
    subtitle: "Man & Van Services",
    description:
      "Reliable man & van for small moves, furniture delivery, and storage runs — priced by distance, no surprises.",
    bullets: [
      "Man & van hire",
      "Furniture delivery",
      "Small house moves",
      "Storage runs",
    ],
    priceMain: "£1.50",
    priceSuffix: "/mile",
    priceNote: "Min charge applies",
    image:
      "https://readdy.ai/api/search-image?query=professional%20mover%20carrying%20cardboard%20boxes%20next%20to%20clean%20white%20delivery%20van%20outside%20modern%20home%20on%20sunny%20day%20warm%20natural%20lighting%20clean%20simple%20background%20minimalist%20style&width=600&height=400&seq=pricing-transport-card-v3&orientation=landscape",
    accent: "from-slate-600 to-slate-800",
    accentLight: "bg-slate-50",
    iconBg: "bg-gradient-to-br from-slate-600 to-slate-800",
    borderColor: "border-slate-200",
    tagColor: "bg-slate-100 text-slate-700",
    tag: "Flexible",
  },
];

function scrollToBook(
  e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
) {
  e.preventDefault();
  window.scrollTo({ top: 0, behavior: "smooth" });
}

interface PricingCardProps {
  item: (typeof cards)[0];
  index: number;
}

function PricingCard({ item, index }: PricingCardProps) {
  const [imgLoaded, setImgLoaded] = useState(false);

  return (
    <a
      href="#book"
      onClick={scrollToBook}
      aria-label={`${item.title} pricing`}
      className={`group relative flex flex-col bg-white rounded-2xl border ${item.borderColor} overflow-hidden transition-all duration-500 hover:-translate-y-3 hover:shadow-2xl cursor-pointer h-full`}
      style={{ animationDelay: `${index * 80}ms` }}
    >
      {/* Image Section */}
      <div className="relative w-full h-48 overflow-hidden">
        {!imgLoaded && (
          <div
            className={`absolute inset-0 ${item.accentLight} animate-pulse flex items-center justify-center`}
          >
            <i className={`${item.icon} text-3xl opacity-20`}></i>
          </div>
        )}
        <img
          src={item.image}
          alt={`${item.title} service`}
          className={`w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110 ${
            imgLoaded ? "opacity-100" : "opacity-0"
          }`}
          onLoad={() => setImgLoaded(true)}
        />
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent"></div>

        {/* Tag badge */}
        <div className="absolute top-3 left-3">
          <span
            className={`${item.tagColor} text-[11px] font-bold px-2.5 py-1 rounded-full backdrop-blur-sm shadow-sm`}
          >
            {item.tag}
          </span>
        </div>

        {/* Price overlay on image */}
        <div className="absolute bottom-3 right-3 bg-white/95 backdrop-blur-sm rounded-xl px-3 py-2 shadow-lg">
          <div className="flex items-baseline gap-0.5">
            <span
              className={`text-lg font-black bg-gradient-to-r ${item.accent} bg-clip-text text-transparent`}
            >
              {item.priceMain}
            </span>
            <span className="text-[11px] text-gray-500 font-medium">
              {item.priceSuffix}
            </span>
          </div>
          <p className="text-[9px] text-gray-400 font-medium">{item.priceNote}</p>
        </div>

        {/* Icon badge bottom-left */}
        <div className="absolute bottom-3 left-3">
          <div
            className={`${item.iconBg} w-10 h-10 rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 group-hover:rotate-3 transition-all duration-300`}
          >
            <i className={`${item.icon} text-lg text-white`}></i>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="p-5 flex flex-col flex-grow">
        {/* Title & Subtitle */}
        <div className="mb-3">
          <h3 className="text-base font-bold text-gray-900 leading-tight group-hover:text-[#ff751f] transition-colors">
            {item.title}
          </h3>
          <p className="text-xs text-gray-500 font-medium mt-0.5">
            {item.subtitle}
          </p>
        </div>

        {/* Description */}
        <p className="text-[13px] text-gray-600 leading-relaxed mb-4 line-clamp-2">
          {item.description}
        </p>

        {/* Bullet list */}
        <ul className="space-y-1.5 mb-5 flex-grow">
          {item.bullets.map((b) => (
            <li key={b} className="flex items-center gap-2">
              <div
                className={`w-4 h-4 rounded-full bg-gradient-to-r ${item.accent} flex items-center justify-center flex-shrink-0`}
              >
                <i className="ri-check-line text-[8px] text-white font-bold"></i>
              </div>
              <span className="text-[13px] text-gray-700 leading-tight">{b}</span>
            </li>
          ))}
        </ul>

        {/* Book button */}
        <button
          className={`w-full py-3 rounded-xl bg-gradient-to-r ${item.accent} text-white text-sm font-bold shadow-lg group-hover:shadow-xl transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2`}
        >
          Book Now
          <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform"></i>
        </button>
      </div>
    </a>
  );
}

export default function PricingSection() {
  return (
    <section className="relative py-16 lg:py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-white to-orange-50/40"></div>

      {/* Decorative Elements */}
      <div className="absolute -top-20 -left-20 w-80 h-80 bg-gradient-to-br from-orange-200/40 to-amber-100/20 rounded-full blur-3xl"></div>
      <div className="absolute -bottom-20 -right-20 w-96 h-96 bg-gradient-to-tl from-teal-200/30 to-cyan-100/20 rounded-full blur-3xl"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-br from-orange-100/20 via-transparent to-teal-100/20 rounded-full blur-3xl"></div>

      {/* Floating shapes */}
      <div className="absolute top-20 left-20 w-16 h-16 border-4 border-orange-200/50 rounded-2xl rotate-12 hidden lg:block"></div>
      <div className="absolute bottom-32 right-24 w-12 h-12 border-4 border-teal-200/50 rounded-full hidden lg:block"></div>
      <div className="absolute top-40 right-32 w-8 h-8 bg-orange-300/30 rounded-full hidden lg:block"></div>
      <div className="absolute bottom-20 left-32 w-10 h-10 bg-teal-300/30 rounded-full hidden lg:block"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-orange-500 to-amber-500 text-white rounded-full text-sm font-bold mb-4 shadow-lg shadow-orange-500/25">
              <i className="ri-price-tag-3-fill"></i>
              <span>Service Pricing</span>
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold text-[#22304e] mb-2">
              Transparent, Upfront Pricing
            </h2>
            <p className="text-gray-600 max-w-xl">
              No hidden fees. Know exactly what you&apos;ll pay before booking.
              Prices vary by location.
            </p>
          </div>

          {/* View Full Pricing CTA */}
          <Link
            to="/pricing"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white border-2 border-orange-500 text-orange-600 font-bold rounded-xl hover:bg-orange-500 hover:text-white transition-all duration-300 shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap self-start lg:self-auto"
          >
            <i className="ri-eye-line text-lg"></i>
            View Full Pricing
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Cards Grid — 3 columns on desktop */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
          {cards.map((c, i) => (
            <PricingCard key={c.key} item={c} index={i} />
          ))}
        </div>

        {/* After Hours Info Bar */}
        <div className="mt-10 bg-gradient-to-r from-[#22304e] to-[#2d4263] rounded-2xl p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex items-center gap-4 flex-1">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center flex-shrink-0 shadow-lg">
              <i className="ri-time-line text-white text-xl"></i>
            </div>
            <div>
              <h4 className="text-white font-bold text-sm mb-0.5">
                After-Hours Pricing
              </h4>
              <p className="text-white/70 text-xs">
                <span className="text-amber-400 font-semibold">6pm–6am:</span>{" "}
                +20% uplift &nbsp;•&nbsp;
                <span className="text-amber-400 font-semibold">
                  After 8pm:
                </span>{" "}
                +£50 late callout may apply
              </p>
            </div>
          </div>
          <Link
            to="/pricing"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold text-sm rounded-lg transition-all cursor-pointer whitespace-nowrap"
          >
            Full Details
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Bottom CTA */}
        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">
            Prices vary by city. View the full pricing page for detailed
            breakdowns.
          </p>
          <Link
            to="/pricing"
            className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-orange-500 to-amber-500 text-white font-bold text-base rounded-xl shadow-xl shadow-orange-500/30 hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-price-tag-3-fill text-xl"></i>
            View Full Pricing Page
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
